import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, vModelText as _vModelText, createElementBlock as _createElementBlock, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card mb-20" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row align-items-end" }
const _hoisted_7 = { class: "col-md-4 mb-3" }
const _hoisted_8 = { class: "col-md-4 mb-3" }
const _hoisted_9 = { class: "col-md-4 mb-3" }
const _hoisted_10 = { class: "col-md-4 mb-3" }
const _hoisted_11 = { class: "col-md-4 mb-3" }
const _hoisted_12 = {
  class: "position-relative mt-2 p-2 bg-white shadow rounded",
  style: {"z-index":"999"}
}
const _hoisted_13 = { class: "col-md-4 mb-3" }
const _hoisted_14 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_15 = { class: "row mb-20" }
const _hoisted_16 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_17 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_18 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_19 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_26 = {
  key: 5,
  class: "text-nowrap"
}
const _hoisted_27 = {
  key: 6,
  class: "text-nowrap"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 7,
  class: "text-nowrap"
}
const _hoisted_30 = {
  key: 0,
  class: "badge rounded-pill fs-13 text-bg-danger"
}
const _hoisted_31 = {
  key: 1,
  class: "badge rounded-pill fs-13 text-bg-primary"
}
const _hoisted_32 = {
  key: 2,
  class: "badge rounded-pill fs-13 text-bg-secondary"
}
const _hoisted_33 = {
  key: 3,
  class: "badge rounded-pill fs-13 text-bg-info"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 5,
  class: "badge rounded-pill fs-13 text-bg-success"
}
const _hoisted_36 = ["onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_37 = {
  key: 10,
  class: "dropdown"
}
const _hoisted_38 = { class: "dropdown-menu" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { key: 2 }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { key: 3 }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { key: 4 }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { key: 5 }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { key: 6 }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { key: 11 }
const _hoisted_57 = {
  class: "modal fade",
  id: "modal_ShowBe",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_58 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_59 = { class: "modal-content p-15 p-md-40" }
const _hoisted_60 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_61 = {
  class: "modal fade",
  id: "modal_ShowReceivedColi",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_62 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_63 = { class: "modal-content p-15 p-md-40" }
const _hoisted_64 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_65 = {
  class: "modal fade",
  id: "modal_transport",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_66 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_67 = { class: "modal-content p-15 p-md-40" }
const _hoisted_68 = { class: "modal-header" }
const _hoisted_69 = { class: "modal-title fs-5" }
const _hoisted_70 = { class: "modal-body" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-12 mb-20" }
const _hoisted_73 = {
  class: "form-group",
  label: "Choisir Transport",
  "label-for": "trans"
}
const _hoisted_74 = { class: "col-md-6 mb-20" }
const _hoisted_75 = {
  class: "form-group",
  "label-for": "name",
  label: "Le nombre de sacs"
}
const _hoisted_76 = {
  key: 0,
  class: "col-md-6 mb-20"
}
const _hoisted_77 = { class: "form-group" }
const _hoisted_78 = { for: "fees_transport" }
const _hoisted_79 = {
  key: 0,
  class: "text-muted d-block mt-5"
}
const _hoisted_80 = {
  key: 1,
  class: "col-md-12 mb-20"
}
const _hoisted_81 = {
  class: "form-group",
  "label-for": "name",
  label: "Code d\\'envoie"
}
const _hoisted_82 = { class: "col-12" }
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_85 = {
  key: 0,
  class: "text-muted d-block mt-5"
}
const _hoisted_86 = {
  key: 1,
  class: "text-muted d-block mt-5"
}
const _hoisted_87 = {
  key: 2,
  class: "text-muted d-block mt-5"
}
const _hoisted_88 = {
  key: 3,
  class: "text-warning d-block"
}
const _hoisted_89 = { class: "modal-footer" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = ["disabled"]
const _hoisted_92 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-5",
  role: "status"
}
const _hoisted_93 = {
  class: "modal fade",
  id: "modal_provider_results",
  tabindex: "-1",
  "aria-labelledby": "providerResultsLabel",
  "aria-hidden": "true"
}
const _hoisted_94 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" }
const _hoisted_95 = { class: "modal-content p-15 p-md-30" }
const _hoisted_96 = { class: "modal-header" }
const _hoisted_97 = {
  id: "providerResultsLabel",
  class: "modal-title fs-5"
}
const _hoisted_98 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_99 = ["disabled"]
const _hoisted_100 = { class: "modal-body" }
const _hoisted_101 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_102 = { class: "table-responsive" }
const _hoisted_103 = { class: "table align-middle api-results" }
const _hoisted_104 = { class: "d-block text-muted" }
const _hoisted_105 = {
  key: 0,
  class: "d-block text-muted"
}
const _hoisted_106 = { class: "api-error" }
const _hoisted_107 = { class: "text-center" }
const _hoisted_108 = { class: "text-end" }
const _hoisted_109 = ["aria-expanded", "onClick"]
const _hoisted_110 = {
  key: 0,
  class: "api-detail"
}
const _hoisted_111 = { colspan: "7" }
const _hoisted_112 = { class: "row g-3" }
const _hoisted_113 = { class: "col-md-6" }
const _hoisted_114 = { class: "text-muted" }
const _hoisted_115 = { class: "col-md-6" }
const _hoisted_116 = { key: 0 }
const _hoisted_117 = { class: "modal-footer" }
const _hoisted_118 = ["disabled"]
const _hoisted_119 = ["disabled"]
const _hoisted_120 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-5",
  role: "status"
}
const _hoisted_121 = {
  class: "modal fade",
  id: "modal_distribution",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_122 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_123 = { class: "modal-content p-15 p-md-40" }
const _hoisted_124 = { class: "modal-header" }
const _hoisted_125 = { class: "modal-title fs-5" }
const _hoisted_126 = { class: "modal-body" }
const _hoisted_127 = { class: "row" }
const _hoisted_128 = { class: "col-12" }
const _hoisted_129 = {
  class: "form-group",
  label: "Auto Distribution",
  "label-for": "distr"
}
const _hoisted_130 = {
  key: 0,
  class: "col-12"
}
const _hoisted_131 = {
  class: "form-group",
  label: "Livreur",
  "label-for": "distr"
}
const _hoisted_132 = {
  key: 0,
  class: "text-muted d-block mt-5"
}
const _hoisted_133 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_MyDateRangePicker = _resolveComponent("MyDateRangePicker")!
  const _component_center = _resolveComponent("center")!
  const _component_templat = _resolveComponent("templat")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_ShowEditBn = _resolveComponent("ShowEditBn")!
  const _component_EditSentNote2 = _resolveComponent("EditSentNote2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.auth.can('ADD_BE_S') && _ctx.auth.can('BE'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                to: "/add-sent-notes"
              }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createTextVNode(" Ajouter Bon d'envoie ( SIMPLE ) ", -1),
                  _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
                ])),
                _: 1,
                __: [24]
              }))
            : _createCommentVNode("", true),
          (_ctx.auth.can('ADD_BE_G') && _ctx.auth.can('BE'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                to: "/add-global-sent"
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createTextVNode(" Ajouter Bon denvoie ( GLOBAL ) ", -1),
                  _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
                ])),
                _: 1,
                __: [25]
              }))
            : _createCommentVNode("", true)
        ]),
        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[27] || (_cache[27] = _createElementVNode("label", null, "Zone Envoi", -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.sent_zone_filter,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sent_zone_filter) = $event)),
                options: _ctx.ZonesList,
                label: "name",
                placeholder: "Toutes les zones"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[28] || (_cache[28] = _createElementVNode("label", null, "Zone Réception", -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.recept_zone_filter,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.recept_zone_filter) = $event)),
                options: _ctx.ZonesList,
                label: "name",
                placeholder: "Toutes les zones"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[30] || (_cache[30] = _createElementVNode("label", null, "Statut", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.searchStatut) = $event))
              }, _cache[29] || (_cache[29] = [
                _createElementVNode("option", { value: "" }, "Statut (Tous)", -1),
                _createElementVNode("option", { value: 0 }, "Attente d'expédition", -1),
                _createElementVNode("option", { value: 1 }, "Expédié", -1),
                _createElementVNode("option", { value: 2 }, "Reçu", -1),
                _createElementVNode("option", { value: 3 }, "Auto Ajout", -1),
                _createElementVNode("option", { value: 4 }, "Hors zone", -1)
              ]), 512), [
                [_vModelSelect, _ctx.filters.searchStatut]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[32] || (_cache[32] = _createElementVNode("label", null, "Type", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.searchType) = $event))
              }, _cache[31] || (_cache[31] = [
                _createElementVNode("option", { value: "" }, "Type (Tous)", -1),
                _createElementVNode("option", { value: "GLOBAL" }, "Global", -1),
                _createElementVNode("option", { value: "SIMPLE" }, "Simple", -1)
              ]), 512), [
                [_vModelSelect, _ctx.filters.searchType]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[34] || (_cache[34] = _createElementVNode("label", null, "Période", -1)),
              _createElementVNode("div", {
                class: "border p-2 cursor-pointer",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCalendar()))
              }, [
                _createTextVNode(_toDisplayString(_ctx.selectedDate?.[0]?.format("DD MMM YYYY") || "—") + " - " + _toDisplayString(_ctx.selectedDate?.[1]?.format("DD MMM YYYY") || "—") + " ", 1),
                _cache[33] || (_cache[33] = _createElementVNode("i", { class: "flaticon-calendar float-end" }, null, -1))
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_12, [
                _createVNode(_component_MyDateRangePicker, {
                  modelValue: _ctx.selectedDate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedDate) = $event)),
                  onOnSelect: _ctx.showCalendar,
                  enableSecondCalendar: true
                }, null, 8, ["modelValue", "onOnSelect"])
              ], 512), [
                [_vShow, _ctx.showCalendarBox]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "btn btn-primary me-2",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
              }, " Filtrer "),
              _createElementVNode("button", {
                class: "btn btn-outline-danger",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
              }, " Annuler ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[35] || (_cache[35] = _createElementVNode("label", null, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.filters.per_page,
              "onUpdate:modelValue": [
                _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.per_page) = $event)),
                _cache[9] || (_cache[9] = ($event: any) => (_ctx.getRecords()))
              ],
              options: [10, 25, 50, 100],
              clearable: false,
              class: "per-page-selector d-inline-block mx-50"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, "sur " + _toDisplayString(_ctx.filters.total) + " entités", 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control shadow-none text-black rounded-0",
              placeholder: "Chercher",
              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.applyFilters())),
              onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters.searchTerm) = $event))
            }, null, 544), [
              [_vModelText, _ctx.filters.searchTerm]
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows,
          loading: _ctx.isLoader,
          "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Bons Sélectionés',
          disableSelectInfo: true,
        },
          onSelectAll: _ctx.selectNotes,
          onSelectedRowsChange: _ctx.onSelectAllNotes
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[36] || (_cache[36] = [
                _createTextVNode("Aucune entrées correspondantes trouvées", -1)
              ])),
              _: 1,
              __: [36]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'note_ref')
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                  _createElementVNode("b", null, _toDisplayString(props.row.note_ref), 1)
                ]))
              : (props.column.field === 'created_at')
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    (props.row.created_at != null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (props.row.userc)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                          _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(_toDisplayString(props.row.userc.name), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (props.column.field === 'sent_time')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                      (props.row.sent_time != null)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.getDate(props.row.sent_time)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (props.row.suser)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                            _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(props.row.suser.name), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (props.column.field === 'delivery_time')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                        (props.row.delivery_time != null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.getDate(props.row.delivery_time)), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (props.row.userd)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                              _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(_toDisplayString(props.row.userd.name), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (props.column.field === 'sending_zone_name')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                          _createElementVNode("h6", null, _toDisplayString(props.row.sending_zone_name), 1),
                          _createElementVNode("span", null, _toDisplayString(props.row.sending_agency_name), 1)
                        ]))
                      : (props.column.field === 'reception_zone_name')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                            _createElementVNode("h6", null, _toDisplayString(props.row.reception_zone_name), 1),
                            _createElementVNode("span", null, _toDisplayString(props.row.reception_agency_name), 1)
                          ]))
                        : (props.column.field === 'transport')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                              _createElementVNode("h6", null, [
                                _createTextVNode(_toDisplayString(props.row.transport) + " ", 1),
                                (props.row.transport && props.row.transport_code)
                                  ? (_openBlock(), _createBlock(_component_templat, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("(" + _toDisplayString(props.row.transport_code) + ")", 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              (props.row.transport && props.row.transport_sacs)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(props.row.transport_sacs) + " Sacs", 1))
                                : _createCommentVNode("", true)
                            ]))
                          : (props.column.field === 'delivered')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(props.row.scanned), 1))
                            : (props.column.field === 'sent')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                  (props.row.sent == 0 && props.row.delivered == 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, " Attente d'expédition "))
                                    : (props.row.sent == 0 && props.row.delivered == 4)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, " Hors Zone "))
                                      : _createCommentVNode("", true),
                                  (props.row.sent == 0 && props.row.delivered == 3)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, " Auto Ajout "))
                                    : (props.row.sent == 1 && props.row.delivered == 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, " Expédié "))
                                      : _createCommentVNode("", true),
                                  (props.row.sent == 0 && props.row.api_failed > 0)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 4,
                                        type: "button",
                                        class: "badge rounded-pill fs-13 text-bg-warning border-0 d-block mt-5",
                                        title: "Voir les colis en erreur",
                                        onClick: ($event: any) => (_ctx.showApiResults(props.row))
                                      }, " API : " + _toDisplayString(props.row.api_failed) + " colis en erreur ", 9, _hoisted_34))
                                    : _createCommentVNode("", true),
                                  (
                props.row.delivered == 1 &&
                (props.row.sent == 1 ||
                  (props.row.sent == 0 &&
                    props.row.reception_agency == props.row.sending_agency))
              )
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, " Reçu "))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (props.column.field === 'recu')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                    (props.row.sent == 1)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (_ctx.auth.can('BE') && _ctx.auth.can('RECEIVE_BE'))
                                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 0,
                                                type: "checkbox",
                                                "onUpdate:modelValue": ($event: any) => ((props.row.recieved) = $event),
                                                class: "custom-control-success",
                                                name: "check-button",
                                                switch: "",
                                                onChange: ($event: any) => (_ctx.recevedNote(props.row)),
                                                value: "1",
                                                "unchecked-value": "0",
                                                indeterminate: false,
                                                disabled: 
                  props.row.delivered == 1 &&
                  (props.row.sent == 1 ||
                    (props.row.sent == 0 &&
                      props.row.reception_agency == props.row.sending_agency))
                
                                              }, null, 40, _hoisted_36)), [
                                                [_vModelCheckbox, props.row.recieved]
                                              ])
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (props.column.field === 'action')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                      _cache[51] || (_cache[51] = _createElementVNode("button", {
                                        class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                                        type: "button",
                                        "data-bs-toggle": "dropdown",
                                        "aria-expanded": "false"
                                      }, [
                                        _createElementVNode("i", { class: "flaticon-dots" })
                                      ], -1)),
                                      _createElementVNode("ul", _hoisted_38, [
                                        (
                    _ctx.auth.can('BE') &&
                    props.row.parcels_num != 0 &&
                    props.row.sent == 0 &&
                    (props.row.delivered == 3 || props.row.delivered == 4) &&
                    props.row.reception_agency != props.row.sending_agency
                  )
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                onClick: ($event: any) => (_ctx.toExpedition(props.row))
                                              }, _cache[40] || (_cache[40] = [
                                                _createElementVNode("i", { class: "flaticon-telegram lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Vers Expédition ", -1)
                                              ]), 8, _hoisted_40)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.auth.can('BE') && props.row.sent == 1)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.showModalRecieved(props.row))
                                              }, _cache[41] || (_cache[41] = [
                                                _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Détails ", -1)
                                              ]), 8, _hoisted_42)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.auth.can('BE') && props.row.sent == 0)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_43, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.showModalRecieved(props.row))
                                              }, _cache[42] || (_cache[42] = [
                                                _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Détails ", -1)
                                              ]), 8, _hoisted_44)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                    _ctx.auth.can('BE') &&
                    props.row.parcels_num != 0 &&
                    props.row.sent == 0 &&
                    props.row.delivered == 0 &&
                    props.row.reception_agency != props.row.sending_agency
                  )
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.transportBon(props.row))
                                              }, _cache[43] || (_cache[43] = [
                                                _createElementVNode("i", { class: "flaticon-express-delivery lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Expédier ", -1)
                                              ]), 8, _hoisted_46)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                    _ctx.auth.can('BE') &&
                    (props.row.api_success > 0 || props.row.api_failed > 0)
                  )
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                onClick: ($event: any) => (_ctx.showApiResults(props.row))
                                              }, _cache[44] || (_cache[44] = [
                                                _createElementVNode("i", { class: "flaticon-list lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Envoi prestataire ", -1)
                                              ]), 8, _hoisted_48)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                    _ctx.auth.can('BE') &&
                    props.row.parcels_num != 0 &&
                    props.row.delivered == 0 &&
                    (props.row.sent == 1 ||
                      (props.row.sent == 0 &&
                        props.row.reception_agency == props.row.sending_agency))
                  )
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.distributionBon(props.row))
                                              }, _cache[45] || (_cache[45] = [
                                                _createElementVNode("i", { class: "flaticon-check lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Reçu ", -1)
                                              ]), 8, _hoisted_50)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                    _ctx.auth.can('BE') &&
                    props.row.parcels_num == 0 &&
                    props.row.delivered == 0 &&
                    props.row.sent == 0
                  )
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.removeNote(props.row))
                                              }, _cache[46] || (_cache[46] = [
                                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Supprimer ", -1)
                                              ]), 8, _hoisted_52)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("li", null, [
                                          (
                      _ctx.auth.can('BE') &&
                      props.row.delivered == 0 &&
                      props.row.sent == 0 &&
                      props.row.type_note == 'SIMPLE'
                    )
                                            ? (_openBlock(), _createBlock(_component_router_link, {
                                                key: 0,
                                                class: "dropdown-item d-flex align-items-center",
                                                to: {
                      name: 'EditSentNotePage',
                      params: {
                        id: props.row.id,
                        refNote: props.row.note_ref,
                      },
                    }
                                              }, {
                                                default: _withCtx(() => _cache[47] || (_cache[47] = [
                                                  _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                                  _createTextVNode(" Modifier ", -1)
                                                ])),
                                                _: 2,
                                                __: [47]
                                              }, 1032, ["to"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("li", null, [
                                          (_ctx.auth.can('BE') && props.row.parcels_num != 0)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.getPDF(props.row))
                                              }, _cache[48] || (_cache[48] = [
                                                _createElementVNode("i", { class: "flaticon-printer lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" PDF ", -1)
                                              ]), 8, _hoisted_53))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("li", null, [
                                          (_ctx.auth.can('BE') && props.row.parcels_num != 0)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.ticketsPDF(props.row))
                                              }, _cache[49] || (_cache[49] = [
                                                _createElementVNode("i", { class: "flaticon-menu-1 lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Tickets ", -1)
                                              ]), 8, _hoisted_54))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("li", null, [
                                          (_ctx.auth.can('BE') && props.row.parcels_num != 0)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.exportExcel(props.row))
                                              }, _cache[50] || (_cache[50] = [
                                                _createElementVNode("i", { class: "flaticon-document lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Excel ", -1)
                                              ]), 8, _hoisted_55))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "loading", "onSelectAll", "onSelectedRowsChange"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.filters,
          offset: 9,
          onPaginate: _ctx.getRecords
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _cache[52] || (_cache[52] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Détails du Bon"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                _createVNode(_component_ShowEditBn, {
                  rowBE: _ctx.noteRow,
                  getRecords: _ctx.getRecords,
                  isOpen: _ctx.isOpen
                }, null, 8, ["rowBE", "getRecords", "isOpen"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _cache[53] || (_cache[53] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Détails du Bon"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                (_ctx.noteRow)
                  ? (_openBlock(), _createBlock(_component_EditSentNote2, {
                      key: 0,
                      rowBE: _ctx.noteRow,
                      getRecords: _ctx.getRecords,
                      type: true,
                      isOpen: _ctx.isOpen
                    }, null, 8, ["rowBE", "getRecords", "isOpen"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("h1", _hoisted_69, " Expedier le bon : " + _toDisplayString(_ctx.TransRow?.note_ref), 1),
            _cache[54] || (_cache[54] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("form", {
              onSubmit: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.expedierBon(_ctx.TransRow.id)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _cache[56] || (_cache[56] = _createElementVNode("label", { for: "driver" }, "Transport", -1)),
                    _createVNode(_component_v_select, {
                      class: "custom-select-height",
                      options: _ctx.zoneTransports,
                      modelValue: _ctx.transport,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.transport) = $event)),
                      label: "name"
                    }, {
                      "no-options": _withCtx(() => _cache[55] || (_cache[55] = [
                        _createTextVNode(" Aucun transport n'est configuré pour la zone de ce bon. ", -1)
                      ])),
                      _: 1
                    }, 8, ["options", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _cache[57] || (_cache[57] = _createElementVNode("label", { for: "sacs" }, "Le nombre de sacs", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "sacs",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.sacs_transport) = $event)),
                      name: "sacs",
                      type: "number",
                      min: "0",
                      step: "1"
                    }, null, 512), [
                      [_vModelText, _ctx.sacs_transport]
                    ])
                  ])
                ]),
                (!_ctx.feesAuto)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("label", _hoisted_78, [
                          _createTextVNode(" Frais de transport (" + _toDisplayString(_ctx.$devis) + ") ", 1),
                          _cache[58] || (_cache[58] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          id: "fees_transport",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.fees_transport) = $event)),
                          name: "fees_transport",
                          type: "number",
                          min: "0",
                          step: "0.01",
                          placeholder: "0.00"
                        }, null, 512), [
                          [_vModelText, _ctx.fees_transport]
                        ]),
                        (_ctx.transport)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_79, " Aucun tarif par sac pour cette zone : saisissez les frais. "))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.transport?.type == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _cache[59] || (_cache[59] = _createElementVNode("label", { for: "code_transport" }, "Code d'envoie", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.code_transport) = $event)),
                          name: "name"
                        }, null, 512), [
                          [_vModelText, _ctx.code_transport]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _cache[61] || (_cache[61] = _createElementVNode("label", { for: "provider" }, [
                      _createTextVNode("Prestataire "),
                      _createElementVNode("small", { class: "text-muted" }, "(facultatif)")
                    ], -1)),
                    _createVNode(_component_v_select, {
                      "input-id": "provider",
                      class: "custom-select-height",
                      options: _ctx.providerList,
                      modelValue: _ctx.provider,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.provider) = $event)),
                      label: "name",
                      disabled: !!_ctx.TransRow?.api_success && !!_ctx.TransRow?.delivery_provider_id
                    }, {
                      "no-options": _withCtx(() => _cache[60] || (_cache[60] = [
                        _createTextVNode(" Aucun livreur prestataire actif. ", -1)
                      ])),
                      option: _withCtx((opt) => [
                        _createTextVNode(_toDisplayString(opt.name) + " ", 1),
                        (!opt.api_configured)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_84, "— sans API"))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["options", "modelValue", "disabled"]),
                    (_ctx.provider && !_ctx.provider.api_configured)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_85, " Prestataire sans API : il est seulement enregistré sur le bon, qui est expédié directement. "))
                      : (_ctx.provider)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_86, " Les colis du bon sont envoyés automatiquement via l'API du prestataire. Si tous les colis sont acceptés, le bon est expédié et un bon de distribution est créé à son nom puis passé à « Reçu ». "))
                        : (_openBlock(), _createElementBlock("small", _hoisted_87, " Sans prestataire, le bon est expédié directement, sans envoi API. ")),
                    (_ctx.TransRow?.api_success && _ctx.TransRow?.delivery_provider_id)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_88, _toDisplayString(_ctx.TransRow.api_success) + " colis déjà créé(s) chez " + _toDisplayString(_ctx.TransRow.delivery_provider_name) + " : le prestataire ne peut plus être changé. ", 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              disabled: _ctx.expediting
            }, " Fermer ", 8, _hoisted_90),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.expedierBon(_ctx.TransRow.id))),
              class: "btn btn-primary",
              disabled: _ctx.expediting
            }, [
              (_ctx.expediting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_92))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.expediting && _ctx.provider?.api_configured ? "Envoi au prestataire…" : "Enregistrer"), 1)
            ], 8, _hoisted_91)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_93, [
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("h1", _hoisted_97, [
              _createTextVNode(" Envoi au prestataire — " + _toDisplayString(_ctx.apiNote?.note_ref) + " ", 1),
              (_ctx.apiNote?.delivery_provider_name)
                ? (_openBlock(), _createElementBlock("small", _hoisted_98, " (" + _toDisplayString(_ctx.apiNote.delivery_provider_name) + ") ", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer",
              disabled: _ctx.retrying
            }, null, 8, _hoisted_99)
          ]),
          _createElementVNode("div", _hoisted_100, [
            (_ctx.apiLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_101, _cache[62] || (_cache[62] = [
                  _createElementVNode("span", {
                    class: "spinner-border",
                    role: "status"
                  }, null, -1)
                ])))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["alert", _ctx.apiNote?.sent == 1 ? 'alert-success' : _ctx.apiCounts.failed ? 'alert-danger' : 'alert-info']),
                    role: "status"
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.apiCounts.success), 1),
                    _cache[65] || (_cache[65] = _createTextVNode(" colis créé(s), ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.apiCounts.failed), 1),
                    _cache[66] || (_cache[66] = _createTextVNode(" en erreur", -1)),
                    (_ctx.apiCounts.sending)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[63] || (_cache[63] = _createTextVNode(", ", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.apiCounts.sending), 1),
                          _cache[64] || (_cache[64] = _createTextVNode(" en cours", -1))
                        ], 64))
                      : _createCommentVNode("", true),
                    _cache[67] || (_cache[67] = _createTextVNode(". ", -1)),
                    (_ctx.apiNote?.sent == 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Le bon est expédié. ")
                        ], 64))
                      : (_ctx.apiCounts.failed)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(" Le bon reste en attente d'expédition tant que des colis sont en erreur. Corrigez-les (ou retirez-les du bon) puis relancez : les colis déjà créés ne sont pas renvoyés. ")
                          ], 64))
                        : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("table", _hoisted_103, [
                      _cache[70] || (_cache[70] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Colis"),
                          _createElementVNode("th", null, "Destinataire"),
                          _createElementVNode("th", null, "Statut"),
                          _createElementVNode("th", null, "N° de suivi"),
                          _createElementVNode("th", null, "Erreur"),
                          _createElementVNode("th", { class: "text-center" }, "Essais"),
                          _createElementVNode("th")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiShipments, (s) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: s.id
                          }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", null, [
                                _createElementVNode("b", null, _toDisplayString(s.coli_code), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createTextVNode(_toDisplayString(s.receiver) + " ", 1),
                                _createElementVNode("small", _hoisted_104, _toDisplayString(s.city_name), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge rounded-pill", {
                            'text-bg-success': s.status === 'success',
                            'text-bg-danger': s.status === 'failed',
                            'text-bg-warning': s.status === 'sending',
                          }])
                                }, _toDisplayString(s.status === "success" ? "Créé" : s.status === "failed" ? "Erreur" : "En cours"), 3),
                                (s.http_code)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_105, "HTTP " + _toDisplayString(s.http_code), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(s.tracking_number || "—"), 1),
                              _createElementVNode("td", _hoisted_106, _toDisplayString(s.error_message || "—"), 1),
                              _createElementVNode("td", _hoisted_107, _toDisplayString(s.attempts), 1),
                              _createElementVNode("td", _hoisted_108, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-light",
                                  "aria-expanded": _ctx.openedShipment === s.id,
                                  onClick: ($event: any) => (_ctx.openedShipment = _ctx.openedShipment === s.id ? null : s.id)
                                }, _toDisplayString(_ctx.openedShipment === s.id ? "Masquer" : "Détails"), 9, _hoisted_109)
                              ])
                            ]),
                            (_ctx.openedShipment === s.id)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_110, [
                                  _createElementVNode("td", _hoisted_111, [
                                    _createElementVNode("div", _hoisted_112, [
                                      _createElementVNode("div", _hoisted_113, [
                                        _createElementVNode("small", _hoisted_114, "Requête — " + _toDisplayString(s.request_url), 1),
                                        _createElementVNode("pre", null, _toDisplayString(_ctx.prettyJson(s.request_payload)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_115, [
                                        _cache[68] || (_cache[68] = _createElementVNode("small", { class: "text-muted" }, "Réponse du prestataire", -1)),
                                        _createElementVNode("pre", null, _toDisplayString(_ctx.prettyJson(s.response_body) || "Aucune réponse"), 1)
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128)),
                        (!_ctx.apiShipments.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_116, _cache[69] || (_cache[69] = [
                              _createElementVNode("td", {
                                colspan: "7",
                                class: "text-center text-muted"
                              }, "Aucun envoi pour ce bon.", -1)
                            ])))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ], 64))
          ]),
          _createElementVNode("div", _hoisted_117, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              disabled: _ctx.retrying
            }, " Fermer ", 8, _hoisted_118),
            (_ctx.apiNote?.sent == 0 && _ctx.apiCounts.failed)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  disabled: _ctx.retrying,
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.retryShipments && _ctx.retryShipments(...args)))
                }, [
                  (_ctx.retrying)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_120))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Relancer les " + _toDisplayString(_ctx.apiCounts.failed) + " colis en erreur ", 1)
                ], 8, _hoisted_119))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_121, [
      _createElementVNode("div", _hoisted_122, [
        _createElementVNode("div", _hoisted_123, [
          _createElementVNode("div", _hoisted_124, [
            _createElementVNode("h1", _hoisted_125, " Reçu le bon : " + _toDisplayString(_ctx.TransRow?.note_ref), 1),
            _cache[71] || (_cache[71] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_126, [
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, [
                _createElementVNode("div", _hoisted_129, [
                  _cache[73] || (_cache[73] = _createElementVNode("label", { for: "driver" }, "Auto distribution", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.auto_distr) = $event))
                  }, _cache[72] || (_cache[72] = [
                    _createElementVNode("option", { value: "0" }, "Non", -1),
                    _createElementVNode("option", { value: "1" }, "Oui", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.auto_distr]
                  ])
                ])
              ]),
              (_ctx.auto_distr == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                    _cache[74] || (_cache[74] = _createElementVNode("label", { for: "driver" }, "Livreur", -1)),
                    _createElementVNode("div", _hoisted_131, [
                      _createVNode(_component_v_select, {
                        options: _ctx.livsZone,
                        modelValue: _ctx.livreur,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.livreur) = $event)),
                        label: "name"
                      }, null, 8, ["options", "modelValue"]),
                      (_ctx.TransRow?.delivery_provider_id)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_132, " Bon lié au prestataire " + _toDisplayString(_ctx.TransRow.delivery_provider_name) + " : seul son livreur peut être choisi. ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_133, [
            _cache[75] || (_cache[75] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.reçuBon(_ctx.TransRow.id))),
              class: "btn btn-primary"
            }, " Enregistrer ")
          ])
        ])
      ])
    ])
  ], 64))
}